import { ReactText } from 'react'
import { ApiProvider } from 'providers/request'
import { Region } from 'models/region'

export const RegionRepository = {
  fetchCountries(): Promise<Region[]> {
    return ApiProvider.get('/countries')
  },
  fetchStates(countryId: ReactText): Promise<Region[]> {
    return ApiProvider.get(`/states/${countryId}`)
  },
  fetchMunicipalities(stateId: ReactText): Promise<Region[]> {
    return ApiProvider.get(`/municipalities/${stateId}`)
  },
  fetchAreas(municipalityId: ReactText): Promise<Region[]> {
    return ApiProvider.get(`/areas/${municipalityId}`)
  },
}
